import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import App from 'browser/App';
import getFlatsWithProperties from 'browser/utils/getFlatsWithProperties';
import axios from 'axios';

const Wrapper = styled.div`
  position: relative;
`;

const BrowserWrapper = ({
  allFlats,
  investment,
  loading,
  loadingText,
  ...props
}) => {
  const [isLoading, setIsLoading] = useState(!allFlats);
  const [flats, setFlats] = useState(getFlatsWithProperties(allFlats));

  useEffect(() => {
    if (!allFlats) {
      (async () => {
        const savedFlats = JSON.parse(
          sessionStorage.getItem(`flats.${investment.investmentName}`)
        );

        if (savedFlats && savedFlats.length) {
          setFlats(savedFlats);
          setIsLoading(false);
        } else {
          try {
            setIsLoading(true);
            const { data } = await axios.get(investment.flatsURL);
            const formatedFlats = getFlatsWithProperties(data);
            setFlats(formatedFlats);
            setIsLoading(false);
            sessionStorage.setItem(
              `flats.${investment.investmentName}`,
              JSON.stringify(formatedFlats)
            );
          } catch (err) {
            console.log(err);
          }
        }
      })();
    }
  }, [allFlats]);

  return (
    <Wrapper id="browser">
      <App
        allFlats={flats}
        investment={investment}
        isLoading={isLoading}
        loadingText={loadingText}
        {...props}
      />
    </Wrapper>
  );
};

BrowserWrapper.propTypes = {
  investment: PropTypes.objectOf(PropTypes.any).isRequired,
  allFlats: PropTypes.arrayOf(PropTypes.object),
  loadingText: PropTypes.string,
  loading: PropTypes.bool,
};

BrowserWrapper.defaultProps = {
  allFlats: null,
  loadingText: `Ładowanie mieszkań`,
  loading: true,
};

export default BrowserWrapper;
